import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b0a3bcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 12 14",
    width: "12",
    height: "14",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      class: "nge-lead-line",
      x1: "6",
      y1: "5",
      x2: "6",
      y2: "15"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      class: "nge-lead-dot",
      cx: "6",
      cy: "3",
      r: "2.6"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span class=\"corner corner-tl\" data-v-4b0a3bcf></span><span class=\"corner corner-tr\" data-v-4b0a3bcf></span><span class=\"corner corner-bl\" data-v-4b0a3bcf></span><span class=\"corner corner-br\" data-v-4b0a3bcf></span><span class=\"nge-chip-scan\" aria-hidden=\"true\" data-v-4b0a3bcf></span>", 5)
const _hoisted_7 = {
  class: "nge-chip-drag",
  title: "Drag anywhere on this box to move it"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-chip-grip",
  "aria-hidden": "true"
}, "⠿", -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-chip-readout" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "13",
  height: "13",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.3 2.3a1.4 1.4 0 0 1 2 2L5.6 12 2.5 13.5 4 10.4z",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.4",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "title"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "nge-chip-foot" }
const _hoisted_18 = { class: "buttonContainer" }
const _hoisted_19 = { class: "stepCounter" }
const _hoisted_20 = ["title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = ["aria-label"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-exit-ask" }, "Exit the tutorial?", -1 /* HOISTED */))
const _hoisted_24 = { class: "nge-exit-sub" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "buttonContainer" }
const _hoisted_27 = {
  key: 2,
  class: "floatingImageRise"
}
const _hoisted_28 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.ready)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "root",
        class: _normalizeClass(["introductionStep", { hasVideo: $setup.computedStep.video !== undefined }])
      }, [
        ($setup.computedStep.modal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nge-overlay-blocker",
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
            }, null, 32 /* HYDRATE_EVENTS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Hidden until it has a position: while the step's target was\n             still being looked up, an empty box sat in the top left corner\n             (Ames, site tour box 4, 2026-10-02). "),
        _createElementVNode("div", {
          class: _normalizeClass(["ng-extend introductionStepAnchor chipBuildIn", [$setup.computedStep.cssClass, { 'nge-no-arrow': !!$props.step.highlight && $setup.tutorialStore.activeTutorial === 4, 'nge-quick-anim': !$setup.computedStep.modal }]]),
          style: _normalizeStyle({ left: $setup.computedStep.left, top: $setup.computedStep.top, visibility: $setup.computedStep.left ? undefined : 'hidden', transform: $setup.dragOffset.x || $setup.dragOffset.y ? `translate(${$setup.dragOffset.x}px, ${$setup.dragOffset.y}px)` : undefined })
        }, [
          _hoisted_1,
          (!$setup.inExitConfirm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["chip", { modal: $setup.computedStep.modal, noborder: $setup.computedStep.noborder, 'nge-chip--dragging': $setup.dragging }]),
                style: _normalizeStyle($setup.chipBounds),
                onPointerdown: $setup.onDragStart
              }, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, [
                    ($props.partLabel)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString($props.partLabel) + " · ", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(_toDisplayString(String($props.stepIndex + 1).padStart(2, '0')) + " / " + _toDisplayString(String($props.totalSteps).padStart(2, '0')), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("button", {
                  class: "exit",
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.inExitConfirm = true))
                }, "×"),
                ($setup.backend.showAdminUi && $props.boxIndex != null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "nge-tut-pencil",
                      title: "Edit the words of this box (admins)",
                      "aria-label": "Edit this box",
                      onClick: _cache[2] || (_cache[2] = $event => ($setup.editing = true))
                    }, _hoisted_11))
                  : _createCommentVNode("v-if", true),
                ($setup.shownTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      ($setup.computedStep.titleIcon)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "title-icon",
                            innerHTML: $setup.computedStep.titleIcon
                          }, null, 8 /* PROPS */, _hoisted_13))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...$setup.shownTitle], (char, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i,
                          class: "title-letter",
                          style: _normalizeStyle({ animationDelay: ($setup.computedStep.modal ? i * 0.06 : Math.min(i * 0.015, 0.18)) + 's' })
                        }, _toDisplayString(char === ' ' ? '\u00A0' : char), 5 /* TEXT, STYLE */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.video)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 2,
                      width: "350",
                      height: "242.81",
                      autoplay: "",
                      loop: "",
                      muted: "",
                      playsinline: "",
                      src: $setup.computedStep.video
                    }, null, 8 /* PROPS */, _hoisted_14))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 3,
                      class: "image",
                      src: $setup.computedStep.image
                    }, null, 8 /* PROPS */, _hoisted_15))
                  : _createCommentVNode("v-if", true),
                ($setup.shownHtml)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "html",
                      innerHTML: $setup.shownHtml,
                      onClick: $setup.onHtmlClick,
                      onMouseover: $setup.onHtmlOver
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (!$setup.computedStep.first)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('back'))),
                          class: "back"
                        }, "back"))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_19, _toDisplayString($props.stepIndex + 1) + "/" + _toDisplayString($props.totalSteps), 1 /* TEXT */),
                    ($setup.computedStep.last)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[4] || (_cache[4] = $event => {if (!$props.step.noConfetti) $setup.launchConfetti(); _ctx.$emit('next')}),
                          class: "next",
                          title: $setup.nextTip
                        }, _toDisplayString($setup.computedStep.nextLabel || 'done'), 9 /* TEXT, PROPS */, _hoisted_20))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: _cache[5] || (_cache[5] = $event => (_ctx.$emit('next'))),
                          class: "next",
                          title: $setup.nextTip
                        }, _toDisplayString($setup.computedStep.nextLabel || 'next'), 9 /* TEXT, PROPS */, _hoisted_21))
                  ]),
                  _createElementVNode("div", {
                    class: "progressBarContainer nge-chip-rail",
                    "aria-label": `Step ${$props.stepIndex + 1} of ${$props.totalSteps}`
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.totalSteps, (n) => {
                      return (_openBlock(), _createElementBlock("i", {
                        key: n,
                        class: _normalizeClass({ on: n <= $props.stepIndex + 1, now: n === $props.stepIndex + 1 })
                      }, null, 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_22)
                ])
              ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */))
            : _createCommentVNode("v-if", true),
          ($setup.inExitConfirm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["chip exitConfirm", { modal: $setup.computedStep.modal }]),
                style: _normalizeStyle($setup.chipBounds)
              }, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createTextVNode("You can start it again any time: the tutorials live in the "),
                  _createElementVNode("span", {
                    class: "nge-tut-burger",
                    innerHTML: $setup.RESOURCES_MENU_SVG
                  }, null, 8 /* PROPS */, _hoisted_25),
                  _createTextVNode(" hamburger menu, top right.")
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = $event => ($setup.inExitConfirm = false)),
                    class: "nge-hud-btn nge-hud-btn--quiet"
                  }, "Keep going"),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = $event => (_ctx.$emit('exitIntro'))),
                    class: "nge-hud-btn"
                  }, "Exit")
                ])
              ], 6 /* CLASS, STYLE */))
            : _createCommentVNode("v-if", true)
        ], 6 /* CLASS, STYLE */),
        ($setup.editing && $props.boxIndex != null)
          ? (_openBlock(), _createBlock($setup["TutorialEditDialog"], {
              key: 1,
              tutorial: $setup.tutorialNum,
              box: $props.boxIndex,
              step: $props.step,
              onClose: _cache[8] || (_cache[8] = $event => ($setup.editing = false))
            }, null, 8 /* PROPS */, ["tutorial", "box", "step"]))
          : _createCommentVNode("v-if", true),
        ($setup.computedStep.floatingImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("img", {
                class: "floatingImageSway",
                src: $setup.computedStep.floatingImage
              }, null, 8 /* PROPS */, _hoisted_28)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}